import { computed } from 'vue'
import setWindowSettings from '@/assets/ts/setting'

setWindowSettings()

export function isExpressCheckoutEnabled() {
	const host = window.BUYANDSHIP.settings.productsharing_express_checkout_host
	return !!(host && host !== '')
}

export function checkIsPhActivation() {
	return window.BUYANDSHIP.settings?.experiments?.ph_activation_2024 === 'yes'
}

export function getPhLayoutType() {
	return 'A'
}

export function checkIsNewReferralFlow() {
	return (
		window.BUYANDSHIP.settings?.experiments?.member_new_referral_flow === 'yes'
	)
}

export const isRegionSupportBuyforyou = computed(() => {
	const buyForYouApiHost = window.BUYANDSHIP.settings.buyforyou_api_host
	return !!buyForYouApiHost && buyForYouApiHost !== ''
})

export function isStagingEnvironment() {
	return window.location.href.includes('https://test-')
}
